import {Component} from '../../core';
import constants from '../../cityConstant.js';
import {isSet,seoUrl,isEmpty} from '../../utils/common';

/**
 * Coworkhome Top Cities component
 */
export class CoworkTopCitiesComponent extends Component {

    static alias = 'cowork-top-cities';

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {

        // Initialize the top cities
        this.initializeTopCities();
    }

    initializeTopCities(){

        this.fetchTopCities(6).then((topCities) => {
            // Update the state
            this.setState({...this.state, topCities});
            
            // Render top cities
            this.renderTopCities(this.state.topCities);
        });
    }

    fetchTopCities(size) {
        // Render top cities
        return fetch(`/homes/re2/coworkTopCities?size=${size}`).then((res) => res.json());
    }

    /**
     * Renders top cities
     * @param {Array} top cities
     */
    renderTopCities(topCities = []) {

        this.refs.topCities.innerHTML = topCities.reduce((html, response) => html + `
            <a onclick="coworkGa('QH_CoWork','Homepage_CoWork_Center-tile', 'QH_CoWork_Homepage_Center-tile_City-tile_click_${this.getCityName(response)}');" href="//www.quikr.com/coworking/coworking-spaces-in-${this.getUrlCityName(response)}-cid_${response.cityId}" class="cw_c_tile ${this.getCityImage(response.cityName)}">
                <h3>${this.getCityName(response)}</h3>
                <p>${response.count} Properties</p>
            </a>`, '');

        if(isEmpty(this.refs.topCities.innerHTML)){
            document.getElementById("topCitiesSection").classList.add('hide');
        }
    }

    getUrlCityName(response){
        let cityName = '';
        if(!isEmpty(response.cityName)){
            cityName = response.cityName.toLowerCase();
        }
        return cityName;
    }

    getCityName(response){
        let cityName = '';
        if(!isEmpty(response.cityName)){
            cityName = response.cityName;
        }
        return cityName;
    }

    getCityImage(cityName){
        var img = 'blr';
        if(cityName == 'Bangalore'){
            img = 'blr';
        }else if(cityName == 'Chennai'){
            img = 'maa';
        }else if(cityName == 'Delhi'){
            img = 'del';
        }else if(cityName == 'Pune'){
            img = 'pnq';
        }else if(cityName == 'Mumbai'){
            img = 'bom';
        }else if(cityName == 'Hyderabad'){
            img = 'hyd';
        }
        return img;
    }

    
}